module.exports = __webpack_public_path__ + "static/img/vivoS7_5G.634271be.png";